
import { Component, OnInit, ViewChild, ViewEncapsulation, inject, signal } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SAUTableModule } from '@some-angular-utils/table';
import { SAUModalService } from '@some-angular-utils/modal';
import { ProductFormComponent } from '../product-form/product-form.component';
import { Urls } from '../../../apiConnection/urls';
import { CustomDeleteComponent } from '../../../components/custom-delete/custom-delete.component';
import { AddButtonComponent } from '@/components/add-button/add-button.component';
import { CentToEurDisplayDirective } from '@/directives/cent-to-eur-display.directive';
import { ApiService } from '@/apiConnection/ApiService';


@Component({
  imports: [
    ReactiveFormsModule,
    RouterModule,
    SAUTableModule,
    AddButtonComponent,
    CentToEurDisplayDirective,
  ],
  templateUrl: './product-list.page.html',
  styleUrl: './product-list.page.scss',
  encapsulation: ViewEncapsulation.None
})
export class ProductListPage implements OnInit {

  @ViewChild('sauTable')
  sauTable: { getItems: () => void; refresh: () => void; } | undefined;

  private sauModalService = inject(SAUModalService);
  private apiService = inject(ApiService);

  // Solo las empresas de tipo restaurante ven el enlace a la vista restaurante
  public isRestaurant = signal(false);

  public url = Urls.urls.products;


  public headers = [
    { name: 'Número', key: 'id_by_company' },
    { name: 'REF', key: 'code' },
    { name: 'NOMBRE', key: 'name' },
    { name: 'PRECIO COSTE', key: 'cost' },
    { name: 'PRECIO VENTA BASE', key: 'sale_price' },
    { name: 'FAMILIA', key: 'category.name' },
    { name: 'VARIACIONES', key: 'variations_count' },
  ];

  ngOnInit() {
    this.apiService.getPetition(Urls.urls.company).subscribe({
      next: (result: any) => {
        this.isRestaurant.set(result?.list?.[0]?.business_type === 'restaurant');
      }
    });
  }

  openEditForm(item: { id: number } = { id: 0 }) {
    const modalRef = this.sauModalService.open(ProductFormComponent, {});
    modalRef.componentInstance.id = item.id;

    modalRef.componentInstance.acceptFunction.subscribe(() => {
      this.sauTable?.getItems();
    });

    modalRef.componentInstance.closeFunction.subscribe(() => {
      modalRef.dismiss();
    });
  }

  openDeleteForm(item: { id: number } = { id: 0 }) {
    const modalRef = this.sauModalService.open(CustomDeleteComponent, {});
    modalRef.componentInstance.id = item.id;
    modalRef.componentInstance.url = this.url;
    modalRef.componentInstance.item = 'producto';

    modalRef.componentInstance.acceptFunction.subscribe(() => {
      this.sauTable?.getItems();
    });

    modalRef.componentInstance.closeFunction.subscribe(() => {
      modalRef.dismiss();
    });
  }

}
